import cx from 'classnames'
import { ContentProps } from './Types'
import Styles from './Content.module.scss'

export const Content = ({ children, fillAvailableSpace, className, withoutFooter }: ContentProps) => (
  <div
    className={cx(Styles.content, className, {
      [Styles.fillAvailableSpace]: fillAvailableSpace,
      [Styles.withoutFooter]: withoutFooter,
    })}
  >
    {children}
  </div>
)
